<template>
  <nav ref="nav" class="menu" v-bind:class="{toggle: isToggle}">
    <div class="panel">
      <router-link v-for="item in menu" v-bind:to="item.link" v-on:click.native="onclose"
                   class="button blue larger"><span>{{item.name}}</span>
      </router-link>
    </div>
    <div class="overlay" v-on:click="onOverlayClick"/>
  </nav>
</template>

<script>

  export default {
    name: 'Nav',
    props: {
      toggleMenu: {
        type: Number
      }
    },
    created() {
      this.menu = {};
      this.$root.$data.menu.all()
        .then(menu => {
          this.menu = menu
        })
    },
    watch: {
      toggleMenu: function () {
        this.isToggle = false
      }
    }
    ,
    methods: {
      onclose() {
        this.isToggle = true
      }
      ,
      onOverlayClick() {
        this.isToggle = !this.isToggle
        this.$emit("toggleMenuClose", this.isToggle);
      }
    }
    ,
    data() {
      return {
        menu: {},
        isToggle: true
      }
    }
    ,
  }

</script>

<style scoped lang="stylus">
  .menu
    .panel
      display flex
      a
        display flex !important
        align-items center
        justify-content center
    margin 10px 0 0
    @media screen and (min-width: 720px)
      .button
        box-shadow 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
        margin-bottom 10px
    @media screen and (max-width: 720px)
      .button
        width 100%
        padding 20px !important
      .panel
        position absolute
        display list-item
        left 0
        top 0
        bottom: 0;
        margin 0
        width 100%
        z-index 9999
        height 100%
        width 75%
        background-color #ffffff
        transform: translate3d(0, 0, 0)
        transition: transform .4s cubic-bezier(.25, .1, .25, 1);

      &.toggle .panel
        transform: translate3d(-100%, 0, 0)
        transition: transform .4s cubic-bezier(.25, .1, .25, 1);
      &.toggle .button
        padding 10px

      .overlay
        z-index 9999
        position absolute
        display block
        background-color #555555
        width 100%
        height 100%
        z-index 9998
        left 0
        top 0
        opacity 0.5
        transform: translate3d(0, 0, 0)

      &.toggle .overlay
        transform: translate3d(-100%, 0, 0)

      &.toggle
        .overlay
          display none
    .button
      @media screen and (max-width: 720px)
        display list-item
</style>